export const CONTENT_TYPES = {
  VOD_ASSET: 'VOD_ASSET',
  TV_SERIES: 'TV_SERIES',
  VOD_BOOKMARK: 'VOD_BOOKMARK',
  EPISODE: 'EPISODE',
  VIEW_ALL: 'VIEW_ALL',
  CHANNEL: 'CHANNEL',
  BANNER: 'BANNER',
  PROGRAM: 'PROGRAM',
} as const;
